module.exports = __webpack_public_path__ + "static/media/SFX_CoinWithBell_Loop_1a.762c6590.mp3";